module.exports = __webpack_public_path__ + "img/image_disam.bfbba5a7.webp";